import React, { useState } from 'react';
import Login from './../Login';
import TestRefDashboard from '../TestRefDashboard';

export default function Home() {
  //const [loggedIn, setLoggedIn] = useState(localStorage.getItem('isLoggedIn'));
  const [loggedIn, setLoggedIn] = useState();

  if (loggedIn === '1') return <TestRefDashboard />;
  else return <Login />;
}
